import { ReactNode } from 'react';

import { HeadingWithQuestionIcon } from './HeadingWithQuestionIcon';

interface ShopSectionProps {
  title: string;
  onOpenModal: () => void;
  children: ReactNode;
}

export function ShopSection({ title, onOpenModal, children }: ShopSectionProps) {
  return (
    <section>
      <HeadingWithQuestionIcon title={title} openModal={onOpenModal} />
      {children}
    </section>
  );
}
